<template>
  <div class="login-modal" v-show="show">
    <div class="modal-body">
      <div class="register-form">
        <div class="form-title">注册登录</div>
        <div class="form">
          <div class="form-item">
            <div class="form-item-label required">公司名称</div>
            <div class="form-item-content">
              <input
                type="text"
                v-model="form.company"
                placeholder="请输入公司名称"
                class="input-box"
                @change="change($event, 'company')"
              />
            </div>
            <div class="error" v-if="errorList.company">
              {{ errorList.company }}
            </div>
          </div>
          <div class="flex-box">
            <div class="flex-grow form-item">
              <div class="form-item-label required">联系人</div>
              <div class="form-item-content">
                <input
                  type="text"
                  v-model="form.contacts"
                  placeholder="请输入联系人"
                  class="input-box"
                  @change="change($event, 'contacts')"
                />
              </div>
              <div class="error" v-if="errorList.contacts">
                {{ errorList.contacts }}
              </div>
            </div>
            <div class="flex-grow form-item tel-item">
              <div class="form-item-label required">联系方式</div>
              <div class="form-item-content">
                <input
                  type="text"
                  v-model="form.tel"
                  placeholder="请输入联系方式"
                  class="input-box"
                  @change="change($event, 'tel')"
                />
              </div>
              <div class="error" v-if="errorList.tel">
                {{ errorList.tel }}
              </div>
            </div>
          </div>
          <div class="form-item">
            <div class="form-item-label required">会议名称</div>
            <div class="form-item-content">
              <input
                type="text"
                v-model="form.meeting"
                placeholder="请输入会议名称"
                class="input-box"
                @change="change($event, 'meeting')"
              />
            </div>
            <div class="error" v-if="errorList.meeting">
              {{ errorList.meeting }}
            </div>
          </div>
          <div class="form-item">
            <div class="form-item-label required">所属类型（行业）</div>
            <div class="form-item-content">
              <input
                type="text"
                v-model="form.industry"
                placeholder="请输入所属类型（行业）"
                class="input-box"
                @change="change($event, 'industry')"
              />
            </div>
            <div class="error" v-if="errorList.industry">
              {{ errorList.industry }}
            </div>
          </div>
          <div class="form-item">
            <div class="form-item-label required">需要的服务</div>
            <div class="form-item-content">
              <input
                type="text"
                v-model="form.serve"
                placeholder="请输入需要的服务"
                class="input-box"
                @change="change($event, 'serve')"
              />
            </div>
            <div class="error" v-if="errorList.serve">
              {{ errorList.serve }}
            </div>
          </div>
          <div class="common-btn primary submit-btn" @click="submit">提交</div>
        </div>
      </div>
      <img src="../assets/image/close.png" class="close-img" @click="close" />
    </div>
  </div>
  <ToastComp v-model:show="showMsg" :message="msg" v-show="showMsg" />
</template>

<script lang="ts" name="LoginModal" setup>
import { ref, reactive, toRefs, computed, unref } from "vue";
import { checkValue } from "../form/util";
import { LabelRule } from "../form";
import { useStore } from "vuex";
import ToastComp from "../components/ToastComp.vue";

interface Form {
  [x: string]: string;
}

const store = useStore();
const props = defineProps({ visible: Boolean });
const { visible } = toRefs(props);
const emit = defineEmits(["update:visible"]);
const show = computed({
  get() {
    return visible.value;
  },
  set(val) {
    emit("update:visible", val);
  },
});

const form = reactive<Form>({
  company: "",
  contacts: "",
  tel: "",
  meeting: "",
  industry: "",
  serve: "",
});
const errorList = reactive<Form>({
  company: "",
  contacts: "",
  tel: "",
  meeting: "",
  industry: "",
  serve: "",
});
const rules: { [key: string]: LabelRule[] } = {
  // company: [{ required: true, message: "请输入公司名称" }],
  // contacts: [{ required: true, message: "请输入联系人" }],
  // tel: [
  //   { required: true, message: "请输入手机号码" },
  //   { regex: "^1[3-9]\\d{9}$", message: "请输入正确的手机号码" },
  // ],
  // meeting: [{ required: true, message: "请输入会议名称" }],
  // industry: [{ required: true, message: "请输入所属类型（行业）" }],
  // serve: [{ required: true, message: "请输入需要的服务" }],
};
const msg = ref("");
const showMsg = ref(false);
const loading = ref(false);
const cleanForm = (formData: Form) => {
  for (let key in formData) {
    formData[key] = "";
  }
};
const checkItem = (key: string) => {
  let value = form[key];
  let rule = rules[key];
  const tip = checkValue(rule, value);
  errorList[key] = tip;
  return tip;
};
const change = (e: Event, key: string) => {
  checkItem(key);
};
const submit = () => {
  if (unref(loading)) {
    return;
  }
  loading.value = true;
  cleanForm(errorList);
  let flag = true;
  for (let key in form) {
    const tip = checkItem(key);
    if (tip && flag) {
      flag = false;
    }
  }
  if (flag) {
    store.commit("setUser", form);
    msg.value = "注册成功";
    showMsg.value = true;
    show.value = false;
  }
  loading.value = false;
};
const close = () => {
  show.value = false;
  cleanForm(form);
  cleanForm(errorList);
};
</script>

<style lang="less" scoped>
.login-modal {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-body {
  position: relative;
  .close-img {
    position: absolute;
    right: 24px;
    top: 18px;
    width: 32px;
    height: 32px;
    cursor: pointer;
  }
}

.form-title {
  color: #1f3251;
  text-align: center;
  font-family: "PingFang SC";
  font-size: 32px;
  font-weight: 700;
  line-height: 32px;
  margin-bottom: 12px;
}
.form-item-label {
  color: rgba(0, 0, 0, 0.9);
  font-size: 14px;
  line-height: 22px;
}
.register-form {
  width: 928px;
  padding: 30px 32px;
  background-color: var(--white);
  border-radius: 12px;
  box-sizing: border-box;
}
.form {
  padding: 0 152px;
}
.form-item {
  margin-bottom: 12px;
  &.tel-item {
    margin-left: 20px;
  }
}
.form-item-label {
  position: relative;
  font-size: 14px;
  padding-bottom: 9px;
  &.required::before {
    content: "*";
    color: #d54941;
    margin-right: 4px;
  }
}
.error {
  font-size: 12px;
  color: #d54941;
  padding: 4px;
}
.input-box {
  height: 32px;
  line-height: 32px;
  padding: 0 8px;
  border-radius: 3px;
  border: 1px solid #dcdcdc;
  box-sizing: border-box;
}
.submit-btn {
  margin: 41px auto 0;
}
</style>
